import { render, staticRenderFns } from "./geolocation.vue?vue&type=template&id=bcd168a2&scoped=true"
import script from "./geolocation.vue?vue&type=script&lang=js"
export * from "./geolocation.vue?vue&type=script&lang=js"
import style0 from "./geolocation.scss?vue&type=style&index=0&id=bcd168a2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd168a2",
  null
  
)

export default component.exports